<style scoped>
.btn-outline-secondary{
  border-color: #ced4da;
  color:#181818
}
</style>
<script>
import { notify } from '@/helpers/notify' 
import { required } from "vuelidate/lib/validators";

export default {
    props:[
        "modelOpen",
        "assignData",
    ],
    data() {
        return {
            submitted: false,
            personelList:[],
            form:{},
        };
    },
    validations: {
      form: {
        appointment_at: { required },
        assigned_userid: { required },
      }
    },
    computed:{
      dnow(){
        const now = new Date();
        return this.appoitmentFormat(now)
      }
    },
    watch:{
      modelOpen(){
          this.form = {
            type: this.assignData.type || 3,
            appointment_at: this.dnow,
            assigned_userid: null,
            content: '',
          }
          this.submitted = false
          this.$v.$reset()
          this.getUsers()
        },
    },
    methods: {
      appoitmentFormat(now){
        const year = now.getFullYear();
        const month = (now.getMonth() + 1).toString().padStart(2, '0');
        const day = now.getDate().toString().padStart(2, '0');
        const hours = now.getHours().toString().padStart(2, '0');
        return `${year}-${month}-${day}T${hours}:00`;
      },
      close(){
          this.$parent.$bvModal.hide('assign_modal')
      },
      getUsers(){
        this.$http.get('/technic-service/listServicePersonel')
        .then(resp => this.personelList = resp.data.content)
      },
      handleSubmit(){
        this.submitted = true;
        this.$v.$touch();
        if (this.$v.$invalid) { return; }

        this.$http.post('transmitter/faults/assign', {
          ...this.form,
          verici_id: this.assignData.tech_id,
        })
          .then(resp => {
              notify.success(resp.data.message || 'Randevu verildi')
              this.$emit('loadItems')
              this.close()
          })
          .catch(err => {
              const message = err.response && err.response.data && err.response.data.message
                ? err.response.data.message
                : 'Randevu verilemedi'
              notify.error(message)
          })
          .finally(() => {
              this.submitted = false;
          })
      },
      today(){
        const now = new Date();
        this.form.appointment_at = this.appoitmentFormat(now)
      },
      tomorrow(){
        const now = new Date();
        const tomorrow = new Date(now);
        tomorrow.setDate(now.getDate() + 1);
        this.form.appointment_at = this.appoitmentFormat(tomorrow)
      },
      nextday(){
        const now = new Date();
        const tomorrow = new Date(now);
        tomorrow.setDate(now.getDate() + 2);
        this.form.appointment_at = this.appoitmentFormat(tomorrow)
      }
    },
};
</script>

<template> 
<b-modal id="assign_modal" title="Randevu Ver"  no-close-on-backdrop hide-footer>
  <form @submit.prevent="handleSubmit">
    <div class="row">  
      <div class="col-12"> 
        <div class="mb-3">
          <label for="appointment_at">Randevu Tarihi</label>
          <div class="input-group mb-3">
            <b-form-input
              v-model="form.appointment_at"
              id="appointment_at"
              type="datetime-local"
              :min="dnow"
              :class="{ 'is-invalid': submitted && $v.form.appointment_at.$error }"
            ></b-form-input>
            <button class="btn btn-outline-secondary" type="button" @click="today()">Bugun</button>
            <button class="btn btn-outline-secondary" type="button" @click="tomorrow()">Yarın</button>
            <button class="btn btn-outline-secondary" type="button" @click="nextday()" >Sonraki Gün</button>
          </div>
          <div
              v-if="submitted && !$v.form.appointment_at.required"
              class="invalid-feedback d-block">
              Bu alanı doldurmak zorunludur.
          </div>
        </div>
      </div>
    </div>
    <div class="row" >
      <div class="col-12">
        <div class="mb-3">
            <label>Atanacak Personel</label>
            <v-select
                label="name" 
                v-model="form.assigned_userid"
                :options="personelList" 
                :reduce="data => data.id"
                :class="{ 'is-invalid': submitted && $v.form.assigned_userid.$error }">
                <span slot="no-options">Sonuç Bulunamadı</span>
            </v-select>
            <div
                v-if="submitted && !$v.form.assigned_userid.required"
                class="invalid-feedback d-block">
                Bu alanı doldurmak zorunludur.
            </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="mb-3">
            <label>Açıklama</label>
            <textarea
                v-model="form.content"
                type="text"
                class="form-control"
              />
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-between mt-3">
        <b-button variant="light" @click="close()">Vazgeç</b-button>
        <b-button 
            type="submit" 
            variant="success" 
            class="ms-1"
            >Randevu Ver
        </b-button>
    </div>
  </form>
</b-modal>
</template>
